export const getVehicleParamsToFetchSections = (params) => ({
  serialNumber: params.serialNumber,
});
